import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type { PromotionsPayload, PromotionsResponse } from "../types/promotions.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.promotions;

export const promotionsService = {
  // lowest series fares per sector type for a departure date range
  async list(payload: PromotionsPayload): Promise<PromotionsResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<PromotionsResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load series fares due to an unexpected error.",
        resData: [],
      };
    }
  },
};
